module.exports = __webpack_public_path__ + "static/media/thumb_Farm_503x503.6704f73b.jpg";